export default __webpack_public_path__ + "static/media/rotate.4856ed6e.svg";